import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">MANUFACTURING</h2>
						<div className="red-border"> </div>
						<p>digiPanda' manufacturing solutions helps to drive your costs down, and provide competitive products and services to your end customers.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
